// ui/button.tsx
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/utils/cn";

export interface ButtonBaseProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    asChild?: boolean;
}

const ButtonBase = React.forwardRef<HTMLButtonElement, ButtonBaseProps>(
    ({ className, asChild = false, ...props }, ref) => {
        const Comp = asChild ? Slot : "button";
        return <Comp className={cn(
            "inline-flex items-center justify-center rounded-md text-sm",
            "font-medium transition-colors focus:outline-none focus:ring-2",
            "focus:ring-ring focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
            className)}
            ref={ref}
            {...props} />;
    }
);
ButtonBase.displayName = "ButtonBase";

export { ButtonBase };
